import React, { useState } from "react";
import { DatePicker, Form, Input, Radio } from "antd";
import moment from "moment";
import "./Registration.css";
import { FaCity, FaRegAddressCard } from "react-icons/fa";
import { LiaCitySolid } from "react-icons/lia";

const Profile = ({ formData, setFormData }) => {
  const [genderValue, setGenderValue] = useState(formData.gender || 1);

  const onChangeGender = (e) => {
    const value = e.target.value;
    setGenderValue(value);
    setFormData({ ...formData, gender: value });
  };

  const onChangeDate = (date, dateString) => {
    setFormData({ ...formData, dob: dateString });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Gender "
          name="gender"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Radio.Group onChange={onChangeGender} value={genderValue}>
            <Radio value="Male">Male</Radio>
            <Radio value="Female">Female</Radio>
          </Radio.Group>
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Date Of Birth"
          name="dob"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD MMM YYYY"
            onChange={onChangeDate}
            value={formData.dob ? moment(formData.dob, "YYYY-MM-DD") : null}
          />
        </Form.Item>
      </div>
      <div className="col-md-12 col-sm-12">
        <Form.Item
          label="Address Line 1"
          name="addressOne"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input
            name="addressOne"
            prefix={<FaRegAddressCard />}
            value={formData.addressOne}
            onChange={handleChange}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
      <div className="col-md-12 col-sm-12">
        <Form.Item
          label="Address Line 2"
          name="addressTwo"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input
            name="addressTwo"
            prefix={<FaRegAddressCard />}
            value={formData.addressTwo}
            onChange={handleChange}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="City "
          name="city"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input
            name="city"
            value={formData.city}
            prefix={<LiaCitySolid />}
            onChange={handleChange}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="State "
          name="state"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input
            name="state"
            value={formData.state}
            onChange={handleChange}
            prefix={<FaCity />}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Zip Code "
          name="zipCode"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
    </>
  );
};

export default Profile;
